import { createFileRoute } from '@tanstack/react-router';
import { ReportViewerPage } from '../../features/reporting/pages/ReportViewerPage';

export const Route = createFileRoute('/_auth/reports/$code')({
  component: ReportViewerPageWrapper,
});

function ReportViewerPageWrapper() {
  const { code } = Route.useParams();
  return <ReportViewerPage code={code} />;
}
